
import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import Header from "../../../Header/Header";
import VICSMenu from "../../VICSMenu";
import DocMenu from "../../../DocMenu";
import GenPdf from "../../../GenPdf";
import history from "../../../Routes/history";
import SignatureCanvas from "react-signature-canvas";
import LoadingOverlay from "../../../LoadingOverlay";
import ImageCropper from "./ImageCropper";
import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import { FileCopy, Check, Close } from '@material-ui/icons';
import { Save as SaveIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from "@material-ui/icons";
import { newEntrepriseValue } from "../../../../redux/actions/entrepriseActions";
import { changeVicValue, fetchCompaniesByDossierLot } from "../../../../redux/actions/vicActions";
import { changeTitleName, changePdfFileName, changeIndication } from "../../../../redux/actions/emailAction";
import { getQuestionsPage, getQuestionsPage5, updateQuestionsPage5, getVicValues, genVicPDF, getVicPDF, getLotName } from "../../Utils"
import "../../../../Styles/VIC/Page-5.scss";

const titles = [
  "Dossier Marché Maître d'ouvrage",
  "Agrément du Maître d'ouvrage",
  "Avez-vous demandé au GO son PPSPS",
  "Plan d'installation de chantier",
  "Accueil du personnel sur le site"
];
const initialQuestions = Array(5).fill({ answer: 0, comment: '' });

const Page5 = ({ vicValue, dossierValue, lotsValue, dispatch, entrepriseValue, companies }) => {
  const sigCanvas = useRef({});
  const prevDossierValue = useRef(dossierValue);
  const prevLotsValue = useRef(lotsValue);
  const prevCompanies = useRef(companies);
  const fileInputRef = useRef(null);
  const prevEntrepriseValue = useRef(entrepriseValue);
  const [disableButton, setDisableButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [tampon, setTampon] = useState(null);
  const [sigLot, setSigLot] = useState(null);
  const [signed, setSigned] = useState(false);
  const [isOpenLink, setIsOpenLink] = useState(false);
  const [link, setLink] = useState('');
  const [copied, setCopied] = useState(false);
  const [organism, setOrganism] = useState("");
  const [specificTasks, setSpecificTasks] = useState([]);
  const [questionsLot, setQuestionsLot] = useState(initialQuestions);
  const [indicationValue, setIndicationValue] = useState("");

  // Nouveaux états pour le découpage d'image
  const [showCropper, setShowCropper] = useState(false);
  const [originalImage, setOriginalImage] = useState(null);

  const refreshData = async () => {
    try {
      setIsLoading(true);
      const data = await getQuestionsPage5(5, vicValue);

      if (data.length === 0) {
        setQuestionsLot(initialQuestions);
        setOrganism("");
        setSigLot(null);
        setSigned(false);
        setTampon(null);
        setSpecificTasks([]);
      } else {
        if (data.tampon === null) {
          setTampon(null);
          setOriginalImage(null);
        } else {
          let base64Flag = 'data:image/jpeg;base64,';
          let imageStr = arrayBufferToBase64(data.tampon.data);
          let imgSrc = base64Flag + imageStr;
          setTampon(imgSrc);
          setOriginalImage(imgSrc);
        }
        setOrganism(data.organism);
        setSigLot(data.sig_lot);
        setSigned(data.sig_lot ? true : false);
        setQuestionsLot(JSON.parse(data.answers))
        data.specific_tasks ? setSpecificTasks(JSON.parse(data.specific_tasks)) : setSpecificTasks([]);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des données:', error);
    } finally {
      setIsLoading(false);
    }
  }

  function arrayBufferToBase64(buffer) {
    let binary = '';
    let bytes = [].slice.call(new Uint8Array(buffer));
    bytes.forEach((b) => binary += String.fromCharCode(b));
    return window.btoa(binary);
  };

  useEffect(() => {
    setDisableButton(true);
    let isMounted = true;

    const fetchQuestionsData = async () => {
      try {
        setIsLoading(true);
        const data = await getQuestionsPage5(5, vicValue);

        if (data.length === 0) {
          setIndicationValue('');
        }

        if (isMounted) {
          if (data.length === 0) {
            setQuestionsLot(initialQuestions);
            setOrganism("");
            setSigLot(null);
            setSigned(false);
            setTampon(null);
            setSpecificTasks([]);
          } else {
            if (data.tampon === null) {
              setTampon(null);
              setOriginalImage(null);
            } else {
              let base64Flag = 'data:image/jpeg;base64,';
              let imageStr = arrayBufferToBase64(data.tampon.data);
              let imgSrc = base64Flag + imageStr;
              setTampon(imgSrc);
              setOriginalImage(imgSrc);
            }
            setOrganism(data.organism);
            setSigLot(data.sig_lot);
            setSigned(data.sig_lot ? true : false);
            setQuestionsLot(JSON.parse(data.answers))
            data.specific_tasks ? setSpecificTasks(JSON.parse(data.specific_tasks)) : setSpecificTasks([]);
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchQuestionsData();
    setDisableButton(false);

    return () => {
      isMounted = false;
    };
  }, [vicValue]);

  useEffect(() => {
    setDisableButton(true);
    const fetchData = async () => {
      if (dossierValue !== prevDossierValue.current || lotsValue !== prevLotsValue.current) {
        await dispatch(fetchCompaniesByDossierLot(dossierValue, lotsValue));
        prevDossierValue.current = dossierValue;
        prevLotsValue.current = lotsValue;
      }
    };

    fetchData();
    setDisableButton(false);
  }, [dossierValue, lotsValue, dispatch]);

  useEffect(() => {
    setDisableButton(true);
    const fetchData = async () => {
      if (companies !== prevCompanies.current) {
        if (companies.length !== 0) {
          await dispatch(newEntrepriseValue(companies[0]));
          const result = await getVicValues(dossierValue, lotsValue, companies[0]);
          await dispatch(changeVicValue(result.id));
        } else {
          await dispatch(changeVicValue(""));
        }
        prevCompanies.current = companies;
      }

      if (entrepriseValue !== prevEntrepriseValue.current) {
        const result = await getVicValues(dossierValue, lotsValue, entrepriseValue);
        await dispatch(changeVicValue(result.id));
        prevEntrepriseValue.current = entrepriseValue;
      }
    };

    fetchData();
    setDisableButton(false);
  }, [companies, entrepriseValue, dispatch]);

  useEffect(() => {
    setDisableButton(true);
    const getIndicationValue = async () => {
      const lotName = await getLotName(lotsValue);
      let conmapyName = '';

      try {
        const parsedValue = JSON.parse(entrepriseValue);
        conmapyName = parsedValue.nom || '';
      } catch (e) {
        conmapyName = entrepriseValue.nom || '';
      }

      setIndicationValue(`${lotName} - ${conmapyName}`);
    };

    getIndicationValue();
    setDisableButton(false);
  }, [entrepriseValue, lotsValue]);

  const handleChangeTampon = (event) => {
    const file = event.target.files[0];
    if (file) {
      let reader = new FileReader();
      reader.onloadend = function () {
        setTampon(reader.result);
        setOriginalImage(reader.result);
      }
      reader.readAsDataURL(file);
    }
  };

  const handleOpenCropper = () => {
    if (originalImage) {
      setShowCropper(true);
    }
  };

  const handleCropConfirm = (croppedImageData) => {
    setTampon(croppedImageData);
    setShowCropper(false);
  };

  const handleCropCancel = () => {
    setShowCropper(false);
  };

  const handleRemoveTampon = () => {
    setTampon(null);
    setOriginalImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleChangeData = (event, index) => {
    const { name, value, checked } = event.target;
    let temp_state = [...questionsLot];
    temp_state[index][name] = name === "answer" ? checked ? 1 : 0 : value;
    setQuestionsLot(temp_state);
  }

  const handleChangeSpecificTasksData = (event, index) => {
    const { name, value, checked } = event.target;
    let temp_state = [...specificTasks];
    temp_state[index][name] = name === "answer" ? checked ? 1 : 0 : value;
    setSpecificTasks(temp_state);
  }

  const handleValidClick = async () => {
    setDisableButton(true);
    let formData = new FormData();

    formData.append("vicValue", vicValue);
    formData.append("answers", JSON.stringify(questionsLot));
    formData.append("specificTasks", JSON.stringify(specificTasks));
    formData.append("organism", organism);
    if (!sigCanvas.current?.isEmpty()) {
      formData.append("sigLot", sigCanvas.current.getTrimmedCanvas().toDataURL());
    } else formData.append("sigLot", sigLot);
    if (!tampon) {
      formData.append("tampon", null);
    } else {
      let data = atob(tampon.split(',')[1]);
      let dataArray = [];
      for (let i = 0; i < data.length; i++) {
        dataArray.push(data.charCodeAt(i));
      }
      let blob = new Blob([new Uint8Array(dataArray)], { type: 'image/jpeg' });
      let file = new File([blob], 'image.jpg', { type: 'image/jpeg', lastModified: Date.now() });
      formData.append("tampon", file);
    }
    await updateQuestionsPage5(formData);
    setDisableButton(false);
  }

  const handleGenClick = async () => {
    setDisableButton(true);
    setFile(null);
    let blob = await genVicPDF(vicValue);
    if (blob) {
      setFile(blob);
      setIsOpen(true);
    }
    setDisableButton(false);
  }

  const handleShowPdf = async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getVicPDF(vicValue, 'pdf');

    if (response.blob.size > 100) {
      setFile(response.blob);
      setIsOpen(true);

      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }

  const handleGetPdfFile = async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getVicPDF(vicValue, 'pdf');
    if (response.blob.size > 100) {
      setFile(response.blob);
      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName))
    }
    setDisableButton(false);
  }

  const handleGetWordFile = async () => {
    setDisableButton(true);
    setFile(null);
    let response = await getVicPDF(vicValue, 'word');
    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(response.blob);
    }
    setDisableButton(false);
  }

  const prevPage = () => {
    history.push("/vic/page-4");
  };

  const nextPage = () => {
    history.push("/vic/page-6");
  };

  const handleChangeTitleName = () => {
    dispatch(changeTitleName(`VIC`));
  };

  const generateLink = async () => {
    try {
      const response = await fetch('/api/vic/generate-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ndossier: dossierValue,
          lot: lotsValue,
          vicValue: vicValue,
          company: entrepriseValue ? typeof entrepriseValue === 'string' ? JSON.parse(entrepriseValue).nom : entrepriseValue.nom : ''
        })
      });

      const { link: generatedLink } = await response.json();
      setLink(generatedLink);
      setIsOpenLink(true);
      setCopied(false);
    } catch (error) {
      console.error('Erreur lors de la generation du lien:', error);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Erreur lors de la copie:', error);
    }
  };

  const handleClose = () => {
    setIsOpenLink(false);
    setCopied(false);
  };

  return (
    <div className="page5">
      {isLoading && <LoadingOverlay />}
      <Header />
      <DocMenu
        file={file}
        getSourceFile={handleGetWordFile}
        getPDF={handleGetPdfFile}
        handleChangeTitleName={handleChangeTitleName}
        updateIndication={() => dispatch(changeIndication(indicationValue))}
      />
      <h1 className="title">Visite d'Inspection Commune (Page 5)</h1>
      <VICSMenu />

      <div className="data-page5">
        {specificTasks.length > 0 &&
          <div className="specific-tasks">
            <h3>TRAVAUX SPÉCIFIQUES AMIANTE ET PLOMB</h3>
            {specificTasks.map(({ answer, title }, index) => {
              return index === 9 ?
                (
                  <div className="specific-task" key={index}>
                    <input name='answer' type="checkbox" checked={answer == 1 ? true : false} onChange={(event) => handleChangeSpecificTasksData(event, index)} />
                    <label>Décliner les modes opératoires du CREP dans votre PPSPS suivant le document remis par l'organisme </label>
                    <input className='organism' name='organism' value={organism} onChange={(event) => setOrganism(event.target.value)} placeholder=" &quot;Nom de l'organisme&quot;" />
                    <label> agrée par la Préfecture</label>
                  </div>
                ) : (
                  <div className="specific-task" key={index}>
                    <input name='answer' type="checkbox" checked={answer == 1 ? true : false} onChange={(event) => handleChangeSpecificTasksData(event, index)} />
                    <label>{title}</label>
                  </div>
                );
            })}
          </div>}
        <table className="custom-table">
          <tbody>
            <tr className="custom-cell" key={0}>
              <td rowSpan={5}>Documents en possession de l'entreprise</td>
              <td className="custom-cell-check"><input name='answer' type="checkbox" checked={questionsLot[0].answer == 1 ? true : false} onChange={(event) => handleChangeData(event, 0)} /></td>
              <td className="custom-cell-label"><label>{titles[0]}</label><input name='comment' value={questionsLot[0].comment} onChange={(event) => handleChangeData(event, 0)} /></td>
            </tr>
            {questionsLot.slice(1).map((item, index) => {
              return (
                <tr className="custom-cell" key={index + 1}>
                  <td className="custom-cell-check"><input name='answer' type="checkbox" checked={questionsLot[index + 1].answer == 1 ? true : false} onChange={(event) => handleChangeData(event, index + 1)} /></td>
                  <td className="custom-cell-label"><label>{titles[index + 1]}</label><input name='comment' value={item.comment} onChange={(event) => handleChangeData(event, index + 1)} /></td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <div className='signature-container'>
          <div className="signature">
            <div className="signature-items">
              <div className="signature-title">
                <label>Signature : </label>
                {signed && <span>Signé </span>}
              </div>
              <SignatureCanvas
                ref={sigCanvas}
                penColor="black"
              />
              <Button className="clear-button" color="primary" variant="contained" onClick={() => sigCanvas.current.clear()}>Effacer</Button>
              <Button color="primary" variant="contained" onClick={generateLink} title="Générer l'URL de signature" disabled={!vicValue}>url</Button>
              <IconButton color="primary" onClick={refreshData} aria-label="rafraîchir les données" title="Rafraîchir les données" disabled={!vicValue}>
                <RefreshIcon />
              </IconButton>
            </div>
            {tampon !== null &&
              <div className="tampon">
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img
                    src={tampon}
                    alt="tampon"
                  />
                  <button
                    type="button"
                    onClick={handleRemoveTampon}
                    style={{
                      top: '-8px',
                      right: '-8px',
                      padding: '0 0 1px 1px',
                      background: '#f44336',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold'
                    }}
                    title="Supprimer le tampon"
                  >
                    ×
                  </button>
                  {originalImage && (
                    <IconButton
                      onClick={handleOpenCropper}
                      style={{
                        top: '-8px',
                        right: '20px',
                        background: '#2196F3',
                        color: 'white',
                        width: '24px',
                        height: '24px',
                        padding: '2px'
                      }}
                      title="Modifier le tampon"
                    >
                      <EditIcon style={{ fontSize: '16px' }} />
                    </IconButton>
                  )}
                </div>
              </div>
            }
          </div>
          <div className="tampon">
            <label>Tampon de l'entreprise : </label>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleChangeTampon}
              className='file-input'
            />
            {originalImage && (
              <div className='info' >
                💡 Utilisez le bouton <EditIcon style={{ fontSize: '12px', verticalAlign: 'middle' }} />  pour découper le tampon si nécessaire.
              </div>
            )}
          </div>
        </div>

        {showCropper && originalImage && (
          <ImageCropper
            src={originalImage}
            onCrop={handleCropConfirm}
            onCancel={handleCropCancel}
          />
        )}

        {isOpenLink && (
          <div className="signature-modal">
            <div className="signature-modal__content">
              <div className="signature-modal__header">
                <h3 className="signature-modal__header-title">Lien de signature</h3>
                <button
                  onClick={handleClose}
                  className="signature-modal__close-btn"
                >
                  <Close />
                </button>
              </div>

              <div className="signature-modal__body">
                <div className="signature-modal__link-container">
                  <div className="signature-modal__link">
                    {link}
                  </div>
                </div>

                <div className="signature-modal__actions">
                  <button
                    onClick={handleCopy}
                    className={`signature-modal__copy-btn ${copied ? 'signature-modal__copy-btn--copied' : ''}`}
                  >
                    {copied ? (
                      <>
                        <Check />
                        Copié !
                      </>
                    ) : (
                      <>
                        <FileCopy />
                        Copier
                      </>
                    )}
                  </button>

                  <button
                    onClick={handleClose}
                    className="signature-modal__ok-btn"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="buttons-container">
          <Button
            color="primary"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={() => handleValidClick()}
            disabled={vicValue === "" || disableButton}
          >
            Enregistrer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<PdfIcon />}
            onClick={() => handleGenClick()}
            disabled={vicValue === "" || disableButton}
          >
            Générer
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<VisibilityIcon />}
            onClick={() => handleShowPdf()}
            disabled={vicValue === "" || disableButton}
          >
            Afficher
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={prevPage}
            disabled={disableButton}
          >
            Précedent
          </Button>
          <Button
            color="primary"
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            onClick={nextPage}
            disabled={disableButton}
          >
            Suivant
          </Button>
          {disableButton && <CircularProgress className="spinner" color="inherit" />}
        </div>
      </div>
      <GenPdf
        file={file}
        isOpen={isOpen}
        closeDoc={() => setIsOpen(false)}
        scale={1}
      />
    </div>
  );
};
const mapStateToProps = (state) => ({
  dossierValue: state.devis.dossierValue,
  vicValue: state.vic.vicValue,
  lotsValue: state.vic.lotsValue,
  companies: state.vic.companies,
  entrepriseValue: state.entreprise.entrepriseValue,
});

export default connect(mapStateToProps)(Page5);
